function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-hot-toast';
import { exchangeAuthorizationCode } from '../utils/tokenExchange';
import { resolveOAuthLoginPath, resolveOAuthPostLoginPath } from './oauth2CallbackRedirect';
export var useOAuth2Callback = function(config) {
    var navigate = useNavigate();
    var location = useLocation();
    var _useState = _sliced_to_array(useState(true), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), errorMsg = _useState1[0], setErrorMsg = _useState1[1];
    var processed = useRef(false);
    var navigated = useRef(false);
    var setAuthenticatedState = useAuth().setAuthenticatedState;
    var instanceId = useRef("oauth-".concat(Date.now())).current;
    // --- Constants ---
    var AUTH_SERVER_URL = config.api.authServerUrl || import.meta.env['VITE_AUTH_SERVER_URL'] || 'https://auth.ugot.uk';
    var API_SERVER_URL = config.api.baseUrl || import.meta.env['VITE_API_SERVER_URL'] || 'https://api.ugot.uk';
    var REDIRECT_URI = config.oauth2.redirectUri;
    var USE_PROXY = true;
    var CLIENT_ID = config.oauth2.clientId;
    var loginPath = resolveOAuthLoginPath(config);
    useEffect(function() {
        var timeoutId = null;
        // URL 파라미터를 즉시 읽고 저장
        var initialSearch = location.search;
        console.log('[useOAuth2Callback] useEffect 실행됨:', {
            instanceId: instanceId,
            initialSearch: initialSearch,
            locationHref: window.location.href,
            processed: processed.current,
            navigated: navigated.current
        });
        // 조건부 실행
        if (initialSearch && initialSearch !== '?' && initialSearch !== '' && !processed.current && !navigated.current) {
            var searchParams = new URLSearchParams(initialSearch);
            var code = searchParams.get('code');
            var error = searchParams.get('error');
            // OAuth2 콜백인 경우에만 처리
            if (code || error) {
                console.log('[useOAuth2Callback] Starting OAuth2 redirect handling...', {
                    instanceId: instanceId,
                    code: code ? "".concat(code.substring(0, 10), "...") : 'missing',
                    error: error
                });
                // URL에서 즉시 파라미터 제거 (중복 처리 방지)
                var url = new URL(window.location.href);
                url.searchParams.delete('code');
                url.searchParams.delete('state');
                url.searchParams.delete('error');
                window.history.replaceState({}, document.title, url.toString());
                var handleOAuthCallback = /*#__PURE__*/ function() {
                    var _ref = _async_to_generator(function() {
                        var storedState, codeVerifier, _ref, tokenData, user, postLoginTarget, err;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    // 중복 처리 방지를 위해 먼저 체크
                                    if (processed.current) {
                                        console.warn('[useOAuth2Callback] Already processed!');
                                        return [
                                            2
                                        ];
                                    }
                                    // 500ms 지연을 추가하여 StrictMode의 빠른 재실행 방지
                                    return [
                                        4,
                                        new Promise(function(resolve) {
                                            return setTimeout(resolve, 500);
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    // 지연 후 다시 체크
                                    if (processed.current) {
                                        console.warn('[useOAuth2Callback] Already processed after delay!');
                                        return [
                                            2
                                        ];
                                    }
                                    processed.current = true; // 처리 시작 표시
                                    // Check for OAuth2 errors
                                    if (error) {
                                        console.error('OAuth2 error:', error);
                                        setErrorMsg(error === 'access_denied' ? '로그인이 취소되었습니다.' : '로그인 중 오류가 발생했습니다.');
                                        setIsLoading(false);
                                        toast.error('로그인에 실패했습니다.');
                                        setTimeout(function() {
                                            return navigate(loginPath, {
                                                replace: true
                                            });
                                        }, 3000);
                                        return [
                                            2
                                        ];
                                    }
                                    // Check for required parameters
                                    if (!code) {
                                        console.error('Missing OAuth2 code parameter');
                                        setErrorMsg('잘못된 로그인 요청입니다.');
                                        setIsLoading(false);
                                        setTimeout(function() {
                                            return navigate(loginPath, {
                                                replace: true
                                            });
                                        }, 3000);
                                        return [
                                            2
                                        ];
                                    }
                                    // OAuth 콜백 검증
                                    // State 검증
                                    storedState = localStorage.getItem('oauth2_state');
                                    codeVerifier = localStorage.getItem('pkce_code_verifier');
                                    if (!storedState || storedState !== searchParams.get('state')) {
                                        setErrorMsg('보안 검증 실패. 다시 로그인해주세요.');
                                        setIsLoading(false);
                                        return [
                                            2
                                        ];
                                    }
                                    if (!codeVerifier) {
                                        setErrorMsg('PKCE 검증 값을 찾을 수 없습니다.');
                                        setIsLoading(false);
                                        return [
                                            2
                                        ];
                                    }
                                    _state.label = 2;
                                case 2:
                                    _state.trys.push([
                                        2,
                                        5,
                                        6,
                                        7
                                    ]);
                                    return [
                                        4,
                                        exchangeAuthorizationCode(code, codeVerifier, REDIRECT_URI, CLIENT_ID, {
                                            USE_PROXY: USE_PROXY,
                                            AUTH_SERVER_URL: AUTH_SERVER_URL,
                                            API_SERVER_URL: API_SERVER_URL
                                        })
                                    ];
                                case 3:
                                    _ref = _state.sent(), tokenData = _ref.tokenData, user = _ref.user;
                                    console.log('[useOAuth2Callback] Token exchange successful:', {
                                        user: user,
                                        access_token: tokenData.access_token.substring(0, 20) + '...',
                                        refresh_token: !!tokenData.refresh_token,
                                        expires_in: tokenData.expires_in,
                                        has_id_token: !!tokenData.id_token
                                    });
                                    // AuthContext 업데이트 - 인증 상태 설정
                                    if (!setAuthenticatedState) {
                                        throw new Error('setAuthenticatedState is not available');
                                    }
                                    return [
                                        4,
                                        setAuthenticatedState(user, tokenData.access_token, tokenData.refresh_token, tokenData.expires_in, tokenData.token_type || 'Bearer', tokenData.id_token // OIDC 로그아웃을 위한 ID 토큰 전달
                                        )
                                    ];
                                case 4:
                                    _state.sent();
                                    console.log('[useOAuth2Callback] setAuthenticatedState 호출 완료');
                                    postLoginTarget = resolveOAuthPostLoginPath(config, localStorage.getItem('oauth2_post_login_redirect'), searchParams.get('state') || storedState);
                                    // localStorage 정리
                                    localStorage.removeItem('oauth2_state');
                                    localStorage.removeItem('pkce_code_verifier');
                                    localStorage.removeItem('oauth2_session_id');
                                    localStorage.removeItem('oauth2_post_login_redirect');
                                    localStorage.removeItem('oauth2_post_login_lang');
                                    // Show success toast and redirect
                                    toast.success('로그인 성공!');
                                    console.log('[useOAuth2Callback] Login successful, navigating to:', postLoginTarget);
                                    navigated.current = true;
                                    // setTimeout을 사용하여 navigate가 확실히 실행되도록 함
                                    setTimeout(function() {
                                        navigate(postLoginTarget, {
                                            replace: true
                                        });
                                    }, 1500);
                                    return [
                                        3,
                                        7
                                    ];
                                case 5:
                                    err = _state.sent();
                                    console.error('[useOAuth2Callback] Unexpected error:', err);
                                    setErrorMsg('로그인 처리 중 예기치 않은 오류가 발생했습니다.');
                                    toast.error('로그인에 실패했습니다.');
                                    setTimeout(function() {
                                        return navigate(loginPath, {
                                            replace: true
                                        });
                                    }, 3000);
                                    return [
                                        3,
                                        7
                                    ];
                                case 6:
                                    setIsLoading(false);
                                    return [
                                        7
                                    ];
                                case 7:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function handleOAuthCallback() {
                        return _ref.apply(this, arguments);
                    };
                }();
                // 비동기 함수 실행
                timeoutId = setTimeout(function() {
                    handleOAuthCallback().catch(function(error) {
                        console.error('[useOAuth2Callback] Unhandled error:', error);
                        setErrorMsg('로그인 처리 중 오류가 발생했습니다.');
                        setIsLoading(false);
                    });
                }, 100);
            } else {
                console.log('[useOAuth2Callback] Not an OAuth2 callback, skipping...');
                setIsLoading(false);
            }
        } else {
            console.log('[useOAuth2Callback] Skipping due to conditions:', {
                hasSearch: !!initialSearch,
                processed: processed.current,
                navigated: navigated.current
            });
            setIsLoading(false);
            // 쿼리 파라미터가 없고 아직 navigate하지 않았으면 메인으로 리다이렉트
            if (!initialSearch && !navigated.current) {
                console.log('[useOAuth2Callback] No query parameters, redirecting to main...');
                navigated.current = true;
                var postLoginTarget = resolveOAuthPostLoginPath(config, localStorage.getItem('oauth2_post_login_redirect'), localStorage.getItem('oauth2_state'));
                setTimeout(function() {
                    return navigate(postLoginTarget, {
                        replace: true
                    });
                }, 100);
            }
        }
        // cleanup 함수 반환
        return function() {
            console.log('[useOAuth2Callback] Cleanup called');
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [
        config,
        location.search,
        loginPath,
        navigate,
        setAuthenticatedState
    ]);
    return {
        isLoading: isLoading,
        errorMsg: errorMsg,
        navigate: navigate
    };
};
